/**
 * Retrieve the environment value based on the current URL
 * @returns {String} - 'E1', 'E2', or 'E3'
 */
const getEnvVal = () => {
  const url = window.location.origin
  if (url.includes('localhost') || url.includes('iar-dev')) return 'E1'
  else if (url.includes('iar-qa')) return 'E2'
  else return 'E3'
}

export const env = getEnvVal()

export const getAPIServerByENV = async () => {
  const SERVER_PORT = import.meta.env.VITE_SERVER_PORT || 8080
  const httpsMode = import.meta.env.VITE_HTTPS_MODE === 'true'
  // in local need to run `npm run serve` during development
  const envUrl = window.location.hostname.includes('localhost')
    ? `http${httpsMode ? 's' : ''}://localhost.aexp.com:${SERVER_PORT}/teamVars`
    : '/teamVars'

  if (!window.env) {
    await fetch(envUrl)
      .then(res => res.json())
      .then(res => {
        window.env = res
        window.env.VITE_IAR_API = window.location.hostname.includes('localhost')
          ? `http${httpsMode ? 's' : ''}://localhost.aexp.com:${SERVER_PORT}`
          : ''
      })
    return window.env.VITE_IAR_API
  }
}

export function generateUUID() {
  if (window?.crypto?.randomUUID) {
    return window.crypto.randomUUID()
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
